module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_sch_tonica.d980f6bb.png";